import React from 'react'
import { Box, Typography } from '@mui/material'
import { advancedColors } from '../../theme'
import EventHistory from './eventHistory/EventHistory'
import EventLogger from './eventLogger/EventLogger'

const Heading = ({ children }: { children: React.ReactNode }) => (
  <Typography component="h3" sx={{ fontSize: '1.25rem', fontWeight: 700, lineHeight: 1.3, color: advancedColors.ink }}>
    {children}
  </Typography>
)

const ParticipantHistoryPanel = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    <Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Heading>Add new history entry</Heading>
      <EventLogger />
    </Box>
    <Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Heading>Participant history</Heading>
      <EventHistory />
    </Box>
  </Box>
)

export default ParticipantHistoryPanel
